import { apiGet, apiSend } from "../../lib/api";
import type { MembersSubscriptionsResponse } from "./types";

export async function fetchMembersSubscriptions(): Promise<MembersSubscriptionsResponse> {
  return apiGet<MembersSubscriptionsResponse>("/members/subscriptions");
}

export async function triggerSubscriptionSync(): Promise<{ success: boolean; count?: number; error?: string }> {
  return apiSend<{ success: boolean; count?: number; error?: string }>("/members/subscriptions/sync", "POST");
}

export interface GenerateEmailMember {
  name: string;
  status: string;
  renewalDate?: string;
  paymentStatus?: string;
}

export async function generateMembersEmail(
  prompt: string,
  members: GenerateEmailMember[]
): Promise<{ subject: string; body: string }> {
  return apiSend<{ subject: string; body: string }>("/members/generate-email", "POST", {
    prompt,
    members,
  });
}

export async function saveSubscriptionNote(subscriptionId: string, note: string): Promise<void> {
  await apiSend(`/members/notes/${encodeURIComponent(subscriptionId)}`, "PUT", { note });
}

export async function deleteSubscriptionNote(subscriptionId: string): Promise<void> {
  await apiSend(`/members/notes/${encodeURIComponent(subscriptionId)}`, "DELETE");
}

export async function sendMembersEmail(args: {
  to: string[];
  subject: string;
  html: string;
}): Promise<{ success: boolean; id: string }> {
  return apiSend<{ success: boolean; id: string }>("/members/send-email", "POST", args);
}
